// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1793683422767
      var cssReload = require("../../../node_modules/.pnpm/@umijs+bundler-webpack@4.7.22_type-fest@4.41.0_typescript@6.0.3_webpack@5.107.2_esbuild@0.28.2_lightningcss@1.33.0_/node_modules/@umijs/bundler-webpack/compiled/mini-css-extract-plugin/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"./","emit":true,"esModule":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  